function checkAccess(requiredScopes: Array<string> | string, userScopes: Array<string> = []) {
   if (Array.isArray(requiredScopes)) {
      return requiredScopes.every((requiredScope) => userScopes.includes(requiredScope));
   }
   return userScopes.includes(requiredScopes);
}

export { checkAccess };
